module.exports = __webpack_public_path__ + "img/vuexy-login-bg.38f263f4.jpg";